import {
  QuestionBubbleHeader,
  QuestionBubbleLabel,
  NormalQuestionBubble,
} from "@/Shared/Components/QuestionBubble";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";

function QuotesPredictedLatestDeliveryDateQuestionBubble() {
  return (
    <NormalQuestionBubble
      description={
        <>
          <QuestionBubbleHeader>
            Predicted Latest Delivery Date
          </QuestionBubbleHeader>
          <QuestionBubbleLabel>
            {/* gap 4 == the 16px that used to sit between the two paragraphs */}
            <Stack gap={4}>
              <div>
                When a quote is generated, FreightSimple automatically analyzes
                data from thousands of shipments, and predicts a realistic
                window for when your freight will deliver based on the carrier,
                service type, industry capacity, and locations involved.
              </div>
              <div>
                Most shipments will deliver within this date range. However
                shipments can be delayed due to a variety of reasons and so
                delivery dates are estimates and not guaranteed.
              </div>
            </Stack>
          </QuestionBubbleLabel>
        </>
      }
      learnMoreUrl="https://help.freightsimple.com/using-freightsimple/tracking/when-will-my-shipment-deliver"
    />
  );
}
export default QuotesPredictedLatestDeliveryDateQuestionBubble;
